import React, {useState, useEffect,useContext} from "react";
import Header from "../components/header/Header";
import '../components/css/newsletter.css'
import { keyContext } from "../components/KeyContext";

import CreateNewsletter from "./CreateNewsletter";
import SentNewsletter from "./SentNewsletter";
import NotSentNewsletter from "./NotSentNewsletter";
import line from '../images/Line 28.png'

export default function Newsletter() {
    useEffect(() => {
        document.title = "nyhedsbreve";
      }, []);
   const { openSideDiv, setOpenSideDiv,} = useContext(keyContext)

      const leftMargin = document?.getElementById('news')?.getBoundingClientRect().x
    // console.log(document.getElementById('news').getBoundingClientRect().x)

const [pageKey, setPageKey] = useState('a');  
let page;
switch (pageKey) {
    case 'a':
      page = <CreateNewsletter />
    break; 
     case 'b':
      page = <NotSentNewsletter leftMargin={leftMargin}/>
    break;
     case 'c':
      page = <SentNewsletter />
    break;
    default:
      page = <CreateNewsletter />
      break;
}

const CMenu = (props) => {
    return  <div className="newsletter_sidemenu"> 
              <button  style={{color:pageKey === 'c' ? 'rgba(152,47,47,1)' : 'rgba(16,16,16,1)', fontWeight: pageKey === 'c' ? '700' : '400'}}  onClick={() => {
          props.onClick("c");setOpenSideDiv(false)
        }}>Udsendte nyhedsbreve</button>
              <img src={line} style={{position:'absolute', right:'40px'}} alt='line'/>
              <span style={{position:'absolute', right:'15px',color:pageKey === 'c' ? 'rgba(70.72,76,1)' : '',fontWeight: pageKey === 'c' ? '700' : '400',fontSize:'18px', opacity: pageKey === 'c' ? '' : '0.3'}} >3</span>
            </div>
}
const BMenu = (props) => {
    return <div className="newsletter_sidemenu"> 
              <button  style={{color:pageKey === 'b' ? 'rgba(152,47,47,1)' : 'rgba(16,16,16,1)', fontWeight: pageKey === 'b' ? '700' : '400'}}  onClick={() => {
          props.onClick("b");setOpenSideDiv(false)
        }}>Ikke udsendte</button>
              <img src={line} style={{position:'absolute', right:'40px'}} alt='line'/>
              <span style={{position:'absolute', right:'15px',color:pageKey === 'b' ? 'rgba(70.72,76,1)' : '',fontWeight: pageKey === 'b' ? '700' : '400',fontSize:'18px', opacity: pageKey === 'b' ? '' : '0.3'}} >2</span>
            </div>
}
const DefaultMenu = (props) => {
    return <div className="newsletter_sidemenu"> 
              <button 
              style={{color:pageKey === 'a' ? 'rgba(152,47,47,1)' : 'rgba(16,16,16,1)', fontWeight: pageKey === 'a' ? '700' : '400'}} 
              onClick={() => {
          props.onClick("a");setOpenSideDiv(false)
        }}>Opret nyhedsbrev</button>
              <img src={line} style={{position:'absolute', right:'40px'}} alt='line'/>
              <span style={{position:'absolute', right:'15px',color:pageKey === 'a' ? 'rgba(70.72,76,1)' : '',fontWeight: pageKey === 'a' ? '700' : '400',fontSize:'18px', opacity: pageKey === 'a' ? '' : '0.3'}} >1</span>
          </div>
    
}

  return (
    <main className="containers">
      <Header newsletterActive="active" />

      <section  id='news' className="newsletter">
        <aside className="side-menu">
             <DefaultMenu onClick={setPageKey} />
             <BMenu onClick={setPageKey} />
             <CMenu onClick={setPageKey} />
           
        </aside>
        <div className="main-menu"> {page}</div>
      </section>
    </main>
  );
}
